export const countryConfig = {
    MX: () => import('../router/mxRoutes'),
    BR: () => import('../router/brRoutes'),
    INT: () => import('../router/intRoutes'),
} as const;